<template>
 <span></span>
</template>

<script>
  export default {
    name: 'ExportPDF',
    props: {
      fctProps: {
        type: String
      },
      contentProps: {
        type: Array
      }
    },
    data: () => ({
      fct: '',
      content: []
    }),
    //computed: {},
    /*watch: { 
      contentProps: function(value){
        console.log('value props', value);
        this.content = value;
        if(this.content) {
          this.createPDF();
          //this.content = undefined;
        }
      }
    },*/
    mounted: function(){
      this.content = this._props.contentProps;
      this.fct = this._props.fctProps;
    },
    methods: {
      getTranslation(val) {
        return this.$t(val);
      },
      createPDF: function(){

        this.content = this._props.contentProps;

        var body_rows = [];

        var document_width = [ 30, 30, 30, 100, 60, 50, 50, 50, 45, 45, 45, 50, 60, 45 ];

        var data_table_row = [];

        pdfMake.fonts = { 
          saysettha_ot: {
            normal: 'saysettha_ot.ttf',
            bold: 'saysettha_ot.ttf',
            italics: 'saysettha_ot.ttf',
            bolditalics: 'saysettha_ot.ttf'
          }
        }

        //console.log(this);

        //HEADER
        var today_date = new Date();
        var today_date_year = today_date.getFullYear();
        var today_date_month = today_date.getMonth() + 1;
        today_date = today_date.getDate() + '/' + today_date_month + '/' + today_date.getFullYear() +  '-' + today_date.getHours() +  ':' + today_date.getMinutes() +  ':' + today_date.getSeconds();
        var header_pdf = this.getTranslation('Generated by')+ ': ' + this.$store.state.auth.username + ' (' + today_date + ')';

        switch(this.fct) {

          case "Project Overview":

          //TITLE
          body_rows.push([
             { colSpan:14, text: this.getTranslation(this.fct), style:'document_title', alignment: 'center', borderColor: ['white', 'white', 'white', 'white']}
          ]);
          body_rows.push([
             { colSpan:14, text: '', style:'document_title', alignment: 'center', borderColor: ['white', 'white', 'white', 'white']}
          ]);

          if(this.content.length !== 0){

            //CONTENT
            for(var i=0; i< this.content.length; i++){

              data_table_row.push([
                  {text: this.getTranslation('Finance Sector ID'),             style:'table_title_header', alignment: 'center', borderColor: ['black', 'black', 'black', 'black']}, 
                  {text: this.getTranslation('Project ID'),                    style:'table_title_header', alignment: 'center', borderColor: ['black', 'black', 'black', 'black']}, 
                  {text: this.getTranslation('Budget ID'),                     style:'table_title_header', alignment: 'center', borderColor: ['black', 'black', 'black', 'black']}, 
                  {text: this.getTranslation('Name'),                          style:'table_title_header', alignment: 'center', borderColor: ['black', 'black', 'black', 'black']}, 
                  {text: this.getTranslation('Sector'),                        style:'table_title_header', alignment: 'center', borderColor: ['black', 'black', 'black', 'black']}, 
                  {text: this.getTranslation('Period'),                        style:'table_title_header', alignment: 'center', borderColor: ['black', 'black', 'black', 'black']}, 
                  {text: this.getTranslation('Project Owner'),                 style:'table_title_header', alignment: 'center', borderColor: ['black', 'black', 'black', 'black']}, 
                  {text: this.getTranslation('Location'),                      style:'table_title_header', alignment: 'center', borderColor: ['black', 'black', 'black', 'black']}, 
                  {text: this.getTranslation('Asset Category'),                style:'table_title_header', alignment: 'center', borderColor: ['black', 'black', 'black', 'black']}, 
                  {text: this.getTranslation('Project contract value (mLAK)'), style:'table_title_header', alignment: 'center', borderColor: ['black', 'black', 'black', 'black']},
                  {text: this.getTranslation('Total Payment (mLAK)'),          style:'table_title_header', alignment: 'center', borderColor: ['black', 'black', 'black', 'black']},
                  {text: this.getTranslation('Contract Payment due (mLAK)'),   style:'table_title_header', alignment: 'center', borderColor: ['black', 'black', 'black', 'black']},
                  {text: this.getTranslation('Reporting'),                     style:'table_title_header', alignment: 'center', borderColor: ['black', 'black', 'black', 'black']},
                  {text: this.getTranslation('Status'),                        style:'table_title_header', alignment: 'center', borderColor: ['black', 'black', 'black', 'black']}
                ]);

              //CONTENT
              //for(var i=0; i< this.content.length; i++){

              var project_date = new Date(this.content[i].project_start_date).toLocaleDateString("en-GB") +' - ' + new Date(this.content[i].project_end_date).toLocaleDateString("en-GB"); 
              var project_location = '';
              if(this.content[i].project_need.province !== null){
                project_location = this.content[i].project_need.province.translation.name;
              }else if(this.content[i].project_need.district !== null){
                project_location = this.content[i].project_need.district.translation.name;
              }else if(this.content[i].project_need.village !== null){
                project_location = this.content[i].project_need.village.translation.name;
              }
              var project_reporting = '';
              if(this.content[i].project_reportings.length !== 0){
                for(var j=0; j< this.content[i].project_reportings.length; j++){
                  project_reporting += this.getTranslation(this.content[i].project_reportings[j].name);
                  if(this.content[i].project_reportings[j].validated){
                    project_reporting +=  ' (V)' + "\n";
                  }else{
                    project_reporting +=  ' (X)' + "\n";
                  }
                }
              }
              var finance_number;
              if(this.content[i].finance_sector_number !== null){
                finance_number = this.content[i].finance_sector_number;
              }else{
                finance_number = '/';
              }
              var project_number;
              if(this.content[i].project_number !== null){
                project_number = this.content[i].project_number;
              }else{
                project_number = '/';
              }
              var budget_number;
              if(this.content[i].budget_number !== null){
                budget_number = this.content[i].budget_number;
              }else{
                budget_number = '/';
              }
              data_table_row.push([
                {text: finance_number,                                                                                  alignment: 'center',bold: true, borderColor: ['black', 'black', 'black', 'black']},
                {text: project_number,                                                                                  alignment: 'center',bold: true, borderColor: ['black', 'black', 'black', 'black']},
                {text: budget_number,                                                                                  alignment: 'center',bold: true, borderColor: ['black', 'black', 'black', 'black']}, 
                {text: this.content[i].project_need.name_en,                                                            alignment: 'center',bold: true, borderColor: ['black', 'black', 'black', 'black']}, 
                {text: this.content[i].project_need.project_sector.translation.name,                                    alignment: 'center',bold: true, borderColor: ['black', 'black', 'black', 'black']}, 
                {text: project_date,                                                                                    alignment: 'center',bold: true, borderColor: ['black', 'black', 'black', 'black']}, 
                {text: this.content[i].project_need.project_owner.translation.name,                                     alignment: 'center',bold: true, borderColor: ['black', 'black', 'black', 'black']}, 
                {text: project_location,                                                                                alignment: 'center',bold: true, borderColor: ['black', 'black', 'black', 'black']}, 
                {text: this.content[i].project_need.asset_type.translation.name, alignment: 'center',bold: true, borderColor: ['black', 'black', 'black', 'black']}, 
                /*{text: this.content[i].project_need.affected_asset_needs[0].affected_asset.asset_type.translation.name, alignment: 'center',bold: true, borderColor: ['black', 'black', 'black', 'black']}, */
                {text: this.content[i].contract_cost.toLocaleString(),                                                  alignment: 'center',bold: true, borderColor: ['black', 'black', 'black', 'black']},
                {text: this.content[i].total_payment.toLocaleString(),                                                  alignment: 'center',bold: true, borderColor: ['black', 'black', 'black', 'black']},
                {text: (this.content[i].contract_cost - this.content[i].total_payment).toLocaleString(),                alignment: 'center',bold: true, borderColor: ['black', 'black', 'black', 'black']},
                {text: project_reporting,                                                                               alignment: 'center',bold: true, borderColor: ['black', 'black', 'black', 'black']},
                {text: this.content[i].project_status.translation.name,                                                 alignment: 'center',bold: true, borderColor: ['black', 'black', 'black', 'black']}
              ]);

              //FIRST SECTION
              data_table_row.push([
                  {colSpan:14, text: this.getTranslation('Project Details'),  decoration: 'underline', style:'sub_title', alignment: 'left', borderColor: ['black', 'white', 'black', 'white']}, 
                ]);
              data_table_row.push([
                { colSpan:14, text: this.getTranslation('Rating') + ": " + this.content[i].project_mark.name + ' (' + this.getTranslation('Evaluation Certificate Expiry date') + ": " + new Date(this.content[i].evaluation_document_deadline).toLocaleDateString("en-GB") + ')',       alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
              ]);

               var comments;
              if(this.content[i].comments && this.content[i].comments !== null){
                comments = this.content[i].comments;
              }else{
                comments = '/';
              }
              data_table_row.push([
                { colSpan:14, text: this.getTranslation('Comments') + ": " + comments, alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
              ]);

              //DETAILS CONTRACTOR
              if(this.content[i].contractor_id !== null){

                data_table_row.push([
                  {colSpan:14, text: this.getTranslation('Contractor') + ": " + this.content[i].contractor.name, alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}, 
                ]);

              }



              //DETAILS PROJECT NEED
              if(this.content[i].project_need_id !== null){

                var plan_description = "";

                plan_description+= this.getTranslation('Rehabilitation Plan') + ': ';
                plan_description+= this.getTranslation('Need Submission Year') + ": " + this.content[i].project_need.year.name + ', ';
                plan_description+= this.getTranslation('Domain') + ": " + this.getTranslation(this.content[i].project_need.domain.translation.name) + ', ';
                plan_description+= this.getTranslation('Sector') + ": " + this.getTranslation(this.content[i].project_need.project_sector.translation.name) + ', ';
                plan_description+= this.getTranslation('Type of Investment') + ": " + this.getTranslation(this.content[i].project_need.project_type.translation.name) + ', ';
                if(this.content[i].project_need.disaster_category !== null && this.content[i].project_need.event_year){
                  plan_description+= this.getTranslation('Disaster') + ": " + this.getTranslation(this.content[i].project_need.disaster_category.translation.name) + ' ' + this.getTranslation(this.content[i].project_need.event_year.name) + ', ';
                }else{
                  plan_description+= this.getTranslation('Disaster') + ": /" + ', ';
                }
                plan_description+= this.getTranslation('Project Owner') + ':' + this.getTranslation(this.content[i].project_need.project_owner.translation.name) + ', ';
                plan_description+= this.getTranslation('Project Owner Mail') + ": " + this.content[i].project_need.project_owner.mail + ', ';
                plan_description+= this.getTranslation('Project Owner Phone Number') + ": " + this.content[i].project_need.project_owner.phone_number + ', ';
                plan_description+= this.getTranslation('Project Owner Organization/Sector') + ": " + this.content[i].project_need.project_owner.organization + ', ';
                if(this.content[i].project_need.province !== null){
                  plan_description+= this.getTranslation('Province') + ": " + this.content[i].project_need.province.translation.name + ', ';
                }
                //console.log('****district', this.content[i].project_need);
                if(this.content[i].project_need.project_need_districts.length !== 0){

                  plan_description+= this.getTranslation('District') + ": ";
                  for(var j=0; j < this.content[i].project_need.project_need_districts[j].length; j++){
                      plan_description += this.content[i].project_need.project_need_districts[j].district.translation.name + ', ';
                  }

                }

                /*if(this.content[i].project_need.district !== null){
                  plan_description+= this.getTranslation('District') + ": " + this.content[i].project_need.district.translation.name + ', ';
                }*/

                /*if(this.content[i].project_need.district !== null){
                  plan_description+= this.getTranslation('Village') + ": " + this.content[i].project_need.village.translation.name;
                } */


                data_table_row.push([
                  {colSpan:14, text: plan_description, alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}, 
                ]);

                /*data_table_row.push([
                  {colSpan:12, text: this.getTranslation('Project Details'),  decoration: 'underline',                   alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}, 
                ]);
                data_table_row.push([
                  { colSpan:12, text: this.getTranslation('Year') + ": " + this.content[i].project_need.year.name,       alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
                ]);
                data_table_row.push([
                  { colSpan:12, text: this.getTranslation('Domain') + ": " + this.getTranslation(this.content[i].project_need.domain.translation.name),    alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
                ]);
                data_table_row.push([
                  { colSpan:12, text: this.getTranslation('Sector') + ": " + this.getTranslation(this.content[i].project_need.project_sector.translation.name),    alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
                ]);
                data_table_row.push([
                  { colSpan:12, text: this.getTranslation('Nature of Operation') + ": " + this.getTranslation(this.content[i].project_need.project_type.translation.name),       alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
                ]);
                data_table_row.push([
                  { colSpan:12, text: this.getTranslation('Disaster') + ": " + this.getTranslation(this.content[i].project_need.disaster.disaster_category.translation.name) + ' ' + this.getTranslation(this.content[i].project_need.disaster.year.name), alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
                ]);

                data_table_row.push([
                  { colSpan:12, text: this.getTranslation('Project Owner') + ':' + this.getTranslation(this.content[i].project_need.project_owner.translation.name), alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']},
                ]);
                data_table_row.push([
                  { colSpan:12, text: this.getTranslation('Project Owner Mail') + ": " + this.content[i].project_need.project_owner.mail, alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
                ]);
                data_table_row.push([
                  { colSpan:12, text: this.getTranslation('Project Owner Phone Number') + ": " + this.content[i].project_need.project_owner.phone_number, alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
                ]);
                data_table_row.push([
                  { colSpan:12, text: this.getTranslation('Project Owner Organization/Sector') + ": " + this.content[i].project_need.project_owner.organization, alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
                ]);
                if(this.content[i].project_need.province !== null){
                  data_table_row.push([
                    { colSpan:12, text: this.getTranslation('Province') + ": " + this.content[i].project_need.province.translation.name, alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
                  ]);
                }else{
                  data_table_row.push([
                    { colSpan:12, text: this.getTranslation('Province') + ": " + '/', alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
                  ]);
                }
                if(this.content[i].project_need.district !== null){
                  data_table_row.push([
                    { colSpan:12, text: this.getTranslation('District') + ": " + this.content[i].project_need.district.translation.name, alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
                  ]);
                }else{
                  data_table_row.push([
                    { colSpan:12, text: this.getTranslation('District') + ": " + '/', alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
                  ]);
                }
                if(this.content[i].project_need.village !== null){
                  data_table_row.push([
                    { colSpan:12, text: this.getTranslation('Village') + ": " + this.content[i].project_need.village.translation.name, alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'black']}
                  ]);
                }else{
                  data_table_row.push([
                    { colSpan:12, text: this.getTranslation('Village') + ": " + '/', alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
                  ]);
                }*/
                
              }

              //INTERLIGNE
              data_table_row.push([
                { colSpan:14, text: "", borderColor: ['black', 'white', 'black', 'white']}
              ]);

              //SOCIAL IMPACT
              var affected_village_consulted_vfm_number, affected_people_consulted_vfm_number, people_poverty_vfm_percent;
              if(this.content[i].affected_village_consulted_vfm_number !== null){
                affected_village_consulted_vfm_number = this.content[i].affected_village_consulted_vfm_number;
              }else{
                affected_village_consulted_vfm_number = 0;
              }
              if(this.content[i].affected_people_consulted_vfm_number !== null){
                affected_people_consulted_vfm_number = this.content[i].affected_people_consulted_vfm_number;
              }else{
                affected_people_consulted_vfm_number = 0;
              }
              if(this.content[i].people_poverty_vfm_percent !== null){
                people_poverty_vfm_percent = this.content[i].people_poverty_vfm_percent;
              }else{
                people_poverty_vfm_percent = 0;
              }
              data_table_row.push([
                {colSpan:14, text: this.getTranslation('Social Impact'),  decoration: 'underline', style:'sub_title', alignment: 'left', borderColor: ['black', 'white', 'black', 'white']}, 
              ]);
              data_table_row.push([
                { colSpan:14, text: this.getTranslation('Number of directly affected villages that the asset services:') + " " + affected_village_consulted_vfm_number, alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
              ]);
              data_table_row.push([
                { colSpan:14, text: this.getTranslation('Number of directly affected people that the asset services:') + " " + affected_people_consulted_vfm_number,    alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
              ]);
              data_table_row.push([
                { colSpan:14, text: this.getTranslation('% of people in the district living below the poverty line:') + " " + people_poverty_vfm_percent,               alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
              ]);


              //INTERLIGNE
              /*data_table_row.push([
                { colSpan:12, text: "", borderColor: ['black', 'white', 'black', 'white']}
              ]);*/


              //DETAILS CONTRACTOR
              /*if(this.content[i].contractor_id !== null){

                data_table_row.push([
                  {colSpan:12, text: this.getTranslation('Contractor Details'),  decoration: 'underline',                   alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}, 
                ]);
                data_table_row.push([
                  { colSpan:12, text: this.getTranslation('Name') + ": " + this.content[i].contractor.name,                 alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
                ]);
                data_table_row.push([
                  { colSpan:12, text: this.getTranslation('Contractor Address') + ": " + this.content[i].contractor.address,           alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
                ]);
                data_table_row.push([
                  { colSpan:12, text: this.getTranslation('Primary Contact and Position') + ": " + this.content[i].contractor.contact,           alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
                ]);
                if(this.content[i].contractor.position !== null){
                  data_table_row.push([
                    { colSpan:12, text: this.getTranslation('Position') + ": " + this.content[i].contractor.position,       alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
                  ]);
                }
                if(this.content[i].contractor.phone_number !== null){
                  data_table_row.push([
                    { colSpan:12, text: this.getTranslation('Phone Number') + ": " + this.content[i].contractor.phone_number, alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
                  ]);
                }

                data_table_row.push([
                  { colSpan:12, text: this.getTranslation('Experience - Demonstrated experience of successfully completing projects of similar size and scope in Lao PDR') + ':' + this.getTranslation(this.content[i].contractor.contractor_experience.translation.name), alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']},
                ]);
                data_table_row.push([
                  { colSpan:12, text: this.getTranslation('Number of Project < 20 bLAK') + ": " + this.content[i].contractor.number_project_under_20, alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
                ]);
                
                data_table_row.push([
                  { colSpan:12, text: this.getTranslation('Number of Project > 20 bLAK') + ": " + this.content[i].contractor.number_project_above_20, alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
                ]);
              }*/


              //INTERLIGNE
              data_table_row.push([
                { colSpan:14, text: "", borderColor: ['black', 'white', 'black', 'white']}
              ]);


              //FINANCIAL SECTION
              data_table_row.push([
                  {colSpan:14, text: this.getTranslation('Finance'),  decoration: 'underline', style:'sub_title', alignment: 'left', borderColor: ['black', 'white', 'black', 'white']}, 
                ]);
              data_table_row.push([
                { colSpan:14, text: this.getTranslation('Assessed Value (mLAK)') + ": " + this.content[i].estimated_cost.toLocaleString(),       alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
              ]);
              var project_cost_category;
              if(this.content[i].estimated_cost/1000 < 20){
                project_cost_category = this.$store.state.referentials.projectClassList.filter(o => o.id === 5)[0].translation.name;
              }else if(this.content[i].estimated_cost/1000 >= 20 && this.content[i].estimated_cost/1000 < 100){
                project_cost_category = this.$store.state.referentials.projectClassList.filter(o => o.id === 4)[0].translation.name;
              }else if(this.content[i].estimated_cost/1000 >= 100 && this.content[i].estimated_cost/1000 < 200){
                project_cost_category = this.$store.state.referentials.projectClassList.filter(o => o.id === 3)[0].translation.name;
              }else if(this.content[i].estimated_cost/1000 >= 200 && this.content[i].estimated_cost/1000 < 400){
                project_cost_category = this.$store.state.referentials.projectClassList.filter(o => o.id === 2)[0].translation.name;
              }else{
                project_cost_category = this.$store.state.referentials.projectClassList.filter(o => o.id === 1)[0].translation.name;
              }
              data_table_row.push([
                { colSpan:14, text: this.getTranslation('Cost Category') + ": " + project_cost_category,       alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
              ]);
              data_table_row.push([
                { colSpan:14, text: this.getTranslation('National Assembly Value (mLAK)') + ": " + this.content[i].national_assembly_cost.toLocaleString(),       alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
              ]);
              data_table_row.push([
                { colSpan:14, text: this.getTranslation('Contract Value (mLAK)') + ": " + this.content[i].contract_cost.toLocaleString(),       alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
              ]);
              if(this.content[i].budget_current_years.length !== 0){
                var budget_current_year = '';
                for(var j=0; j < this.content[i].budget_current_years.length; j++){
                  budget_current_year += this.content[i].budget_current_years[j].amount + ' ' + this.getTranslation('mLAK') + ' (' + this.getTranslation('Year: ') + this.content[i].budget_current_years[j].year.name + '),';
                }
                data_table_row.push([
                  { colSpan:14, text: this.getTranslation('Budget Current Year (mLAK)') + ": " + budget_current_year,       alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
                ]);
              }
              var on_debt;
              if(this.content[i].on_debt){
                on_debt = 'Yes';
              }else{
                on_debt = 'No';
              }
              data_table_row.push([
                { colSpan:14, text: this.getTranslation('On Debt') + ": " + this.getTranslation(on_debt),       alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
              ]);

              if(this.content[i].project_budget_other_funding.length !== 0){ //total_other_project_funds
                var other_budget = this.content[i].total_other_project_funds + ' ( ';

                for(var j=0; j < this.content[i].project_budget_other_funding.length; j++){
                  other_budget += this.content[i].project_budget_other_funding[j].amount + ' ' + this.getTranslation('mLAK') + ' (' + new Date(this.content[i].project_budget_other_funding[j].createdAt).toLocaleDateString("en-GB") + '),';
                }
                other_budget += ' )';


              }else{
                other_budget = 0;
              }
              data_table_row.push([
                { colSpan:14, text: this.getTranslation('Other Fund (mLAK)') + ": " + other_budget,       alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
              ]);

              data_table_row.push([
                { colSpan:14, text: this.getTranslation('Total Payment (mLAK)') + ": " + this.content[i].total_payment,       alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
              ]);

              data_table_row.push([
                { colSpan:14, text: this.getTranslation('Work performed value (mLAK)') + ": " + this.content[i].total_work_value,       alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
              ]);

              var expense_rows = [];

              if(this.content[i].project_works && this.content[i].project_works.length !== 0){

                expense_rows.push([
                  {text: this.getTranslation('Work Performed (mLAK)'), alignment: 'center', borderColor: ['#b9bbbd', '#b9bbbd', '#b9bbbd', '#b9bbbd'], fontSize: 8,bold: true},
                  {text: this.getTranslation('Payment (mLAK)'), alignment: 'center', borderColor: ['#b9bbbd', '#b9bbbd', '#b9bbbd', '#b9bbbd'], fontSize: 8,bold: true},
                  {text: this.getTranslation('Date'), alignment: 'center', borderColor: ['#b9bbbd', '#b9bbbd', '#b9bbbd', '#b9bbbd'], fontSize: 8,bold: true},
                  {text: this.getTranslation('Document'), alignment: 'center', borderColor: ['#b9bbbd', '#b9bbbd', '#b9bbbd', '#b9bbbd'], fontSize: 8,bold: true},
                  {text: this.getTranslation('Contract Fund'), alignment: 'center', borderColor: ['#b9bbbd', '#b9bbbd', '#b9bbbd', '#b9bbbd'], fontSize: 8,bold: true}
                ]);

                for(var j=0; j < this.content[i].project_works.length; j++){
                  for(var k=0; k < this.content[i].project_works[j].work_expenses.length; k++){
                    var fund;
                    if(this.content[i].project_works[j].work_expenses[k].funding_source_id === 1){
                      fund = this.getTranslation('Yes');
                    }else{
                      fund = this.getTranslation('No');
                    }

                    if(this.content[i].project_works[j].work_expenses.length === 1){
                      expense_rows.push([
                        { text: this.content[i].project_works[j].work_value.toLocaleString(), borderColor: ['#b9bbbd', '#b9bbbd', '#b9bbbd', '#b9bbbd'] },
                        { text: this.content[i].project_works[j].work_expenses[k].expense_amount.toLocaleString(), borderColor: ['#b9bbbd', '#b9bbbd', '#b9bbbd', '#b9bbbd'] }, 
                        { text: new Date(this.content[i].project_works[j].work_expenses[k].createdAt).toLocaleDateString("en-GB"), borderColor: ['#b9bbbd', '#b9bbbd', '#b9bbbd', '#b9bbbd'] }, 
                        { text: this.content[i].project_works[j].work_expenses[k].document_name, borderColor: ['#b9bbbd', '#b9bbbd', '#b9bbbd', '#b9bbbd'] },
                        { text: fund, borderColor: ['#b9bbbd', '#b9bbbd', '#b9bbbd', '#b9bbbd'] },
                      ]);
                    }else{

                      if(k === 0){
                        expense_rows.push([
                          { text: this.content[i].project_works[j].work_value.toLocaleString(), borderColor: ['#b9bbbd', '#b9bbbd', '#b9bbbd', 'white'] },
                          { text: this.content[i].project_works[j].work_expenses[k].expense_amount.toLocaleString(), borderColor: ['#b9bbbd', '#b9bbbd', '#b9bbbd', 'white'] }, 
                          { text: new Date(this.content[i].project_works[j].work_expenses[k].createdAt).toLocaleDateString("en-GB"), borderColor: ['#b9bbbd', '#b9bbbd', '#b9bbbd', 'white'] }, 
                          { text: this.content[i].project_works[j].work_expenses[k].document_name, borderColor: ['#b9bbbd', '#b9bbbd', '#b9bbbd', 'white'] },
                          { text: fund, borderColor: ['#b9bbbd', '#b9bbbd', '#b9bbbd', 'white'] },
                        ]);
                      }else if(k !== 0 && k < this.content[i].project_works[j].work_expenses.length-1){
                        expense_rows.push([
                          { text: '', borderColor: ['#b9bbbd', '#b9bbbd', '#b9bbbd', 'white'] },
                          { text: this.content[i].project_works[j].work_expenses[k].expense_amount.toLocaleString(), borderColor: ['#b9bbbd', '#b9bbbd', '#b9bbbd', 'white'] }, 
                          { text: new Date(this.content[i].project_works[j].work_expenses[k].createdAt).toLocaleDateString("en-GB"), borderColor: ['#b9bbbd', '#b9bbbd', '#b9bbbd', 'white'] }, 
                          { text: this.content[i].project_works[j].work_expenses[k].document_name, borderColor: ['#b9bbbd', '#b9bbbd', '#b9bbbd', 'white'] },
                          { text: fund, borderColor: ['#b9bbbd', '#b9bbbd', '#b9bbbd', 'white'] },
                        ]);
                      }else{
                        expense_rows.push([
                          { text: '', borderColor: ['#b9bbbd', '#b9bbbd', '#b9bbbd', '#b9bbbd'] },
                          { text: this.content[i].project_works[j].work_expenses[k].expense_amount.toLocaleString(), borderColor: ['#b9bbbd', '#b9bbbd', '#b9bbbd', '#b9bbbd'] }, 
                          { text: new Date(this.content[i].project_works[j].work_expenses[k].createdAt).toLocaleDateString("en-GB"), borderColor: ['#b9bbbd', '#b9bbbd', '#b9bbbd', '#b9bbbd'] }, 
                          { text: this.content[i].project_works[j].work_expenses[k].document_name, borderColor: ['#b9bbbd', '#b9bbbd', '#b9bbbd', '#b9bbbd'] },
                          { text: fund, borderColor: ['#b9bbbd', '#b9bbbd', '#b9bbbd', '#b9bbbd'] },
                        ]);
                      }

                    }
              

                  }
                }

                /*for(var j=0; j < this.content[i].project_budget_contract[0].budget_expenses.length; j++){
                  expense_rows.push([
                    { text: this.content[i].project_budget_contract[0].budget_expenses[j].work_value.toLocaleString(), borderColor: ['#b9bbbd', '#b9bbbd', '#b9bbbd', '#b9bbbd'] },
                    { text: this.content[i].project_budget_contract[0].budget_expenses[j].amount.toLocaleString(), borderColor: ['#b9bbbd', '#b9bbbd', '#b9bbbd', '#b9bbbd'] }, 
                    { text: new Date(this.content[i].project_budget_contract[0].budget_expenses[j].createdAt).toLocaleDateString("en-GB"), borderColor: ['#b9bbbd', '#b9bbbd', '#b9bbbd', '#b9bbbd'] }, 
                    { text: this.content[i].project_budget_contract[0].budget_expenses[j].document_name, borderColor: ['#b9bbbd', '#b9bbbd', '#b9bbbd', '#b9bbbd'] },
                    { text: this.getTranslation('Yes'), borderColor: ['#b9bbbd', '#b9bbbd', '#b9bbbd', '#b9bbbd'] },
                  ]);
                }

                for(var k=0; k < this.content[i].budget_expense_other_funding.length; k++){
                  expense_rows.push([
                    { text: this.content[i].budget_expense_other_funding[k].work_value.toLocaleString(), borderColor: ['#b9bbbd', '#b9bbbd', '#b9bbbd', '#b9bbbd'] },
                    { text: this.content[i].budget_expense_other_funding[k].amount.toLocaleString(), borderColor: ['#b9bbbd', '#b9bbbd', '#b9bbbd', '#b9bbbd'] }, 
                    { text: new Date(this.content[i].budget_expense_other_funding[k].createdAt).toLocaleDateString("en-GB"), borderColor: ['#b9bbbd', '#b9bbbd', '#b9bbbd', '#b9bbbd'] }, 
                    { text: this.content[i].budget_expense_other_funding[k].document_name, borderColor: ['#b9bbbd', '#b9bbbd', '#b9bbbd', '#b9bbbd'] },
                    { text: this.getTranslation('No'), borderColor: ['#b9bbbd', '#b9bbbd', '#b9bbbd', '#b9bbbd'] },
                  ]);
                }*/

                data_table_row.push([
                  {
                    colSpan:14, 
                    fontSize: 7,
                    borderColor: ['black', 'black', 'black', 'white'],
                    table:{
                      headerRows: 1,
                      widths: [ 135, 135, 135, 135, 135 ],
                      body: expense_rows
                    },
                    //border width
                    layout: {
                      hLineWidth: function (i, node) {
                        return 0.5;
                      },
                      vLineWidth: function (i, node) {
                        return 0.5;
                      }
                    }
                  }
                ]);


              }else{
                data_table_row.push([
                  { colSpan:14, text: this.getTranslation('No Expense'), borderColor: ['black', 'white', 'black', 'white']}
                ]);

              }

              //INTERLIGNE
              data_table_row.push([
                {colSpan:14, text: "", borderColor: ['black', 'white', 'black', 'white']}
              ]);

              //PROJECT DOCUMENTS
              //instruction
              if(this.content[i].project_instruction_documents){
                data_table_row.push([
                  {colSpan:14, text: this.getTranslation('Project Instruction Document'),  decoration: 'underline', style:'sub_title', alignment: 'left', borderColor: ['black', 'white', 'black', 'white']}, 
                ]);
                if(this.content[i].project_instruction_documents.length !== 0){
                  for(var j=0; j < this.content[i].project_instruction_documents.length; j++){
                    var document_text = this.getTranslation(this.content[i].project_instruction_documents[j].name) + ': ' + this.content[i].project_instruction_documents[j].original_name + ' (' + new Date(this.content[i].project_instruction_documents[j].updatedAt).toLocaleDateString("en-GB") + ')';
                    data_table_row.push([
                      { colSpan:14, text: document_text, alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
                    ]);
                  }
                }else{
                  data_table_row.push([
                    { colSpan:14, text: this.getTranslation('No Document'), alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
                  ]);
                }
              }


              //reporting
              if(this.content[i].project_reporting_documents){

                data_table_row.push([
                  {colSpan:14, text: this.getTranslation('Project Reporting Document'),  decoration: 'underline', style:'sub_title', alignment: 'left', borderColor: ['black', 'white', 'black', 'white']}, 
                ]);

                if(this.content[i].project_reporting_documents.length !== 0){
                  for(var j=0; j < this.content[i].project_reporting_documents.length; j++){
                    if(this.content[i].project_reporting_documents[j].length !== 0){
                      data_table_row.push([
                        {colSpan:14, text: this.content[i].project_reporting_documents[j].name + ' :' , decoration: 'underline', style:'reporting_name',  alignment: 'left', borderColor: ['black', 'white', 'black', 'white']}, 
                      ]);

                      for(var k=0; k < this.content[i].project_reporting_documents[j].reporting_documents.length; k++){

                        var reporting_date;
                        if(this.content[i].project_reporting_documents[j].reporting_documents[k].updatedAt){
                          reporting_date = new Date(this.content[i].project_reporting_documents[j].reporting_documents[k].updatedAt).toLocaleDateString("en-GB");
                        }else{
                          reporting_date = '/';
                        }

                        if(this.content[i].project_reporting_documents[j].reporting_documents[k].length !== 0){
                          var document_text = this.getTranslation(this.content[i].project_reporting_documents[j].reporting_documents[k].name) + ': ' + this.content[i].project_reporting_documents[j].reporting_documents[k].original_name + ' (' + reporting_date + ')';
                          data_table_row.push([
                            { colSpan:14, text: document_text, alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
                          ]);
                        }else{
                          data_table_row.push([
                            { colSpan:14, text: this.getTranslation('No Document'), alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
                          ]);
                        }

                      }

                    }else{
                      data_table_row.push([
                        { colSpan:14, text: this.getTranslation('No Document'), alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
                      ]);
                    }
                  }
                }else{
                  data_table_row.push([
                    { colSpan:14, text: this.getTranslation('No Document'), alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
                  ]);
                }
              }

              //completion
              if(this.content[i].project_completion_documents){

                data_table_row.push([
                  {colSpan:14, text: this.getTranslation('Project Completion Document'),  decoration: 'underline',style:'sub_title', alignment: 'left', borderColor: ['black', 'white', 'black', 'white']}, 
                ]);
                if(this.content[i].project_completion_documents.length !== 0){
                  for(var j=0; j < this.content[i].project_completion_documents.length; j++){

                    var completion_date;
                    if(this.content[i].project_completion_documents[j].updatedAt){
                      completion_date = new Date(this.content[i].project_completion_documents[j].updatedAt).toLocaleDateString("en-GB");
                    }else{
                      completion_date = '/';
                    }

                    var document_text = this.getTranslation(this.content[i].project_completion_documents[j].name) + ': ' + this.content[i].project_completion_documents[j].original_name + ' (' + completion_date + ')';
                    data_table_row.push([
                      { colSpan:14, text: document_text, alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
                    ]);
                  }
                }else{
                  data_table_row.push([
                    { colSpan:14, text: this.getTranslation('No Document'), alignment: 'left',bold: true, borderColor: ['black', 'white', 'black', 'white']}
                  ]);
                }
              }

              //INTERLIGNE
              data_table_row.push([
                { colSpan:14, text: "", borderColor: ['black', 'black', 'black', 'black']}
              ]);
              data_table_row.push([
                { colSpan:14, text: "", borderColor: ['white', 'white', 'white', 'white']}
              ]);
              data_table_row.push([
                { colSpan:14, text: "", borderColor: ['white', 'white', 'white', 'white']}
              ]);
              data_table_row.push([
                { colSpan:14, text: "", borderColor: ['white', 'black', 'white', 'black']}
              ]);


            }

          }else{

            data_table_row.push([
                  {text: this.getTranslation('Finance Sector ID'),             style:'table_title_header', alignment: 'center', borderColor: ['black', 'black', 'black', 'black']}, 
                  {text: this.getTranslation('Project ID'),                    style:'table_title_header', alignment: 'center', borderColor: ['black', 'black', 'black', 'black']}, 
                  {text: this.getTranslation('Budget ID'),                     style:'table_title_header', alignment: 'center', borderColor: ['black', 'black', 'black', 'black']}, 
                  {text: this.getTranslation('Name'),                          style:'table_title_header', alignment: 'center', borderColor: ['black', 'black', 'black', 'black']}, 
                  {text: this.getTranslation('Sector'),                        style:'table_title_header', alignment: 'center', borderColor: ['black', 'black', 'black', 'black']}, 
                  {text: this.getTranslation('Period'),                        style:'table_title_header', alignment: 'center', borderColor: ['black', 'black', 'black', 'black']}, 
                  {text: this.getTranslation('Project Owner'),                 style:'table_title_header', alignment: 'center', borderColor: ['black', 'black', 'black', 'black']}, 
                  {text: this.getTranslation('Location'),                      style:'table_title_header', alignment: 'center', borderColor: ['black', 'black', 'black', 'black']}, 
                  {text: this.getTranslation('Asset Category'),                style:'table_title_header', alignment: 'center', borderColor: ['black', 'black', 'black', 'black']}, 
                  {text: this.getTranslation('Project contract value (mLAK)'), style:'table_title_header', alignment: 'center', borderColor: ['black', 'black', 'black', 'black']},
                  {text: this.getTranslation('Total Payment (mLAK)'),          style:'table_title_header', alignment: 'center', borderColor: ['black', 'black', 'black', 'black']},
                  {text: this.getTranslation('Contract Payment due (mLAK)'),   style:'table_title_header', alignment: 'center', borderColor: ['black', 'black', 'black', 'black']},
                  {text: this.getTranslation('Reporting'),                     style:'table_title_header', alignment: 'center', borderColor: ['black', 'black', 'black', 'black']},
                  {text: this.getTranslation('Status'),                        style:'table_title_header', alignment: 'center', borderColor: ['black', 'black', 'black', 'black']}
                ]);

            data_table_row.push([
                { colSpan:14, text: this.getTranslation('No data available'), borderColor: ['black', 'black', 'black', 'black']}
              ]);
          }

            body_rows.push([
                  {
                    colSpan:14,
                    margin: [-30, 5, 5, 5],
                    borderColor: ['white', 'white', 'white', 'white'],
                    table:{
                      headerRows: 0,
                      pageBreak: 'after',
                      widths: document_width,
                      body: data_table_row
                    },
                    //border width
                    layout: {
                      hLineWidth: function (i, node) {
                        return 0.5;
                      },
                      vLineWidth: function (i, node) {
                        return 0.5;
                      }
                    }
                  }
            ]);

          //}

          break;
        }


        //var docDefinition = { content: this.rows };

        /*var docDefinition = { content: '' };
        docDefinition.content += this.fct;

        for(var i=0; i< this.content.length; i++){

          docDefinition.content += '<p>' 
                                + this.content[i].project_number
                                + '</p>';
        }*/

        //docDefinition.content += this.content;

        var docDefinition = {
            pageSize: 'A4',
            pageOrientation: 'landscape',
            footer: function(currentPage, pageCount) { 
              return [
              {text: currentPage.toString() + ' of ' + pageCount, alignment: 'center', fontSize: 8 }
              ]
            },
            header: function(currentPage, pageCount, pageSize) {
            // you can apply any logic and return any valid pdfmake element
              return [
                { text: header_pdf, alignment: 'left',fontSize: 8 },
                { canvas: [ { type: 'rect', x: 170, y: 32, w: pageSize.width - 170, h: 40 } ] }
              ]
            },
            content: [
              {
                color: '#5f6163',
                fontSize: 8,
                table: {
                  // headers are automatically repeated if the table spans over multiple pages
                  // you can declare how many rows should be treated as headers
                  headerRows: 0,
                  widths: document_width,
                  body: body_rows
                },
                //border width
                layout: {
                  hLineWidth: function (i, node) {
                    return 0.5;
                  },
                  vLineWidth: function (i, node) {
                    return 0.5;
                  }
                }
              }
            ],
            pageBreakBefore: function(currentNode, followingNodesOnPage, nodesOnNextPage, previousNodesOnPage) {
              //return currentNode.headlineLevel === 1 && followingNodesOnPage.length === 0;
              return currentNode.pageNumbers.length > 1 && currentNode.unbreakable;
            },
              // https://pdfmake.github.io/docs/fonts/custom-fonts-client-side/url/
              styles: {
                'document_title': {
                  fontSize: 12, 
                  bold: true,
                  color:'black',
                  alignment: 'center'
                },
                'table_title_header': {
                  color: 'black',
                  fillColor: '#eeeeff',
                  bold: true
                },
                'sub_title': {
                  color: 'black',
                  fontSize: 9,
                  bold: true
                },
                'reporting_name': {
                  color: 'black',
                  fontSize: 8,
                  bold: false
                },
              },
              defaultStyle: {
                font:'saysettha_ot'
              }
        };

        pdfMake.createPdf(docDefinition).download(this.fct + '.pdf');

      },
    }
  }
</script>
